(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const enhanceBestForTags = () => {
    const section = document.querySelector("[id$='__section_6EAHkG']");
    const contentBlock = section?.querySelector("[id$='__text_YgGUMg']");

    if (!contentBlock || contentBlock.dataset.fvTagsReady === 'true') return;

    const source = contentBlock.querySelector('.metafield-rich_text_field') || contentBlock;
    const items = (source.innerText || '')
      .split(/\n+|[,，;；|•]+/)
      .map((item) => item.replace(/^[\s#\-–—·]+/, '').trim())
      .filter(Boolean)
      .filter((item, index, values) => values.indexOf(item) === index);

    if (!items.length) return;

    const tags = document.createElement('div');
    tags.className = 'fv-best-for-tags';
    tags.setAttribute('role', 'list');

    items.forEach((item) => {
      const tag = document.createElement('span');
      tag.className = 'fv-best-for-tag';
      tag.setAttribute('role', 'listitem');
      tag.textContent = `#${item}`;
      tags.appendChild(tag);
    });

    source.replaceChildren(tags);
    contentBlock.dataset.fvTagsReady = 'true';
  };

  const initMobileFeatureTabs = () => {
    const section = document.querySelector("[id$='__section_YzqzY9']");
    const layout = section?.querySelector("[id$='__group_basic_kDAhtj'] > .group-block-content");
    const panels = [
      { element: section?.querySelector("[id$='__group_kiCKAx']"), label: 'Selling Points', id: 'fv-selling-points-panel' },
      { element: section?.querySelector("[id$='__group_yKXQ34']"), label: 'Key Features', id: 'fv-key-features-panel' },
    ];

    if (!layout || panels.some((panel) => !panel.element) || layout.dataset.fvTabsReady === 'true') return;

    const tablist = document.createElement('div');
    tablist.className = 'fv-mobile-feature-tabs';
    tablist.setAttribute('role', 'tablist');
    tablist.setAttribute('aria-label', 'Product highlights');
    let activeIndex = 0;

    const buttons = panels.map((panel, index) => {
      const button = document.createElement('button');
      const tabId = `fv-feature-tab-${index}`;

      panel.element.id = panel.element.id || panel.id;
      panel.element.classList.add('fv-mobile-feature-panel');
      panel.element.setAttribute('role', 'tabpanel');
      panel.element.setAttribute('aria-labelledby', tabId);
      button.type = 'button';
      button.id = tabId;
      button.className = 'fv-mobile-feature-tab';
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-controls', panel.element.id);
      button.textContent = panel.label;
      tablist.appendChild(button);
      return button;
    });

    const syncTabs = () => {
      const isMobile = mobileQuery.matches;
      panels.forEach((panel, index) => {
        const isActive = isMobile && activeIndex === index;
        panel.element.hidden = isMobile && !isActive;
        buttons[index].classList.toggle('is-active', isActive);
        buttons[index].setAttribute('aria-selected', String(isActive));
        buttons[index].setAttribute('aria-expanded', String(isActive));
        buttons[index].tabIndex = isActive || !isMobile || activeIndex === -1 ? 0 : -1;
      });
    };

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        activeIndex = activeIndex === index ? -1 : index;
        syncTabs();
      });
    });

    layout.parentElement.insertBefore(tablist, layout);
    layout.dataset.fvTabsReady = 'true';
    mobileQuery.addEventListener?.('change', syncTabs);
    syncTabs();
  };

  const initNewProductPageMobile = () => {
    if (!document.body.classList.contains('template-product--new-product-page')) return;

    enhanceBestForTags();
    initMobileFeatureTabs();

    if (mobileQuery.matches) {
      const specificationToggle = Array.from(
        document.querySelectorAll("[id$='__section_product_tabs_46L9aY'] .toggle-title")
      ).find((toggle) => toggle.textContent.trim().startsWith('Specifications'));

      if (specificationToggle) {
        specificationToggle.classList.add('is-open');
        specificationToggle.querySelector('button')?.setAttribute('aria-expanded', 'true');
      }
    }

    const stickyBars = Array.from(document.querySelectorAll('sticky-atc'));
    const mainCta = document.querySelector(
      '.main-product-information .add-to-cart-button, .main-product-information product-form-component .product-form__submit'
    );

    if (!stickyBars.length || !mainCta) return;

    let scheduled = false;
    const updateStickyBar = () => {
      scheduled = false;
      if (window.matchMedia('(min-width: 750px)').matches) {
        stickyBars.forEach((bar) => bar.classList.remove('fv-sticky-visible'));
        return;
      }

      const ctaRect = mainCta.getBoundingClientRect();
      const ctaIsVisible = ctaRect.bottom > 0 && ctaRect.top < window.innerHeight;
      const pageBottom = window.scrollY + window.innerHeight;
      const documentHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
      const nearFooter = pageBottom >= documentHeight - 80;
      const shouldShow = !ctaIsVisible && !nearFooter;

      stickyBars.forEach((bar) => bar.classList.toggle('fv-sticky-visible', shouldShow));
      const visibleHeight = shouldShow ? Math.max(...stickyBars.map((bar) => bar.offsetHeight), 0) : 0;
      document.body.style.setProperty('--sticky-atc-height', `${visibleHeight}px`);
    };

    const scheduleUpdate = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(updateStickyBar);
    };

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    scheduleUpdate();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewProductPageMobile, { once: true });
  } else {
    initNewProductPageMobile();
  }
})();